// LICENSE_CODE ZON
'use strict'; /*jslint node:true, browser:true*/
(function(){
var define;
var is_node = typeof module=='object' && module.exports;
if (!is_node)
    define = self.define;
else
    define = require('../../../util/require_node.js').define(module, '../');
define(['jquery', '/util/user_agent.js', '/util/etask.js', '/util/escape.js'],
    function($, user_agent, etask, zescape){

var E = {};
var perr_url = 'perr.brightdata.com';
var b = user_agent.guess_browser();
var sys = user_agent.guess(), os = sys.os;

function keys(o){ return Object.keys(Object(o)); }
function each(o, func, ctx){
    // XXX pavelp: underscore prior to 1.7.0 uses native forEach.
    // 1.7.0+ underscore doesn't use it.
    if (Object(o)===o && o.forEach===Array.prototype.forEach)
    {
        o.forEach(func, ctx);
        return o;
    }
    var f = (ctx===void 0) ? func : func.bind(ctx), i;
    var len = o && typeof o.length=='number' ? o.length : -1;
    if (len===len|0 && len>=0)
    {
        for (i=0; i<len; i++)
            f(o[i], i, o);
    }
    else
    {
        var okeys = keys(o);
        for (i=0, len=okeys.length; i<len; i++)
            f(o[okeys[i]], okeys[i], o);
    }
    return o;
}

function to_form_data(o){
    // don't use FormData for <=IE10
    if (window.FormData===undefined || window.XDomainRequest!==undefined)
        return o;
    var data = new FormData();
    each(o, function(v, k){ data.append(k, v); });
    return data;
}

E.send_beacon = function(url, data){
    if (navigator && navigator.sendBeacon)
    {
        var res, e;
        try { res = navigator.sendBeacon(url, data); } catch(_e){ e = _e; }
        if (res)
            return;
        if (!e)
            E.perr({id: 'send_beacon_err'});
    }
    var is_xdr = window.XDomainRequest!==undefined ;
    var xhr = is_xdr ? new XDomainRequest() : new XMLHttpRequest();
    xhr.open('POST', url, false);
    if (!is_xdr)
    {
        xhr.setRequestHeader('Accept', '*/*');
        if (typeof data=='string')
        {
            xhr.setRequestHeader('Content-Type', 'text/plain;charset=UTF-8');
            xhr.responseType = 'text/plain';
        }
        else if (Object.prototype.toString.call(data)=='[object Blob]' &&
            data.type)
        {
            xhr.setRequestHeader('Content-Type', data.type);
        }
    }
    // XXX gilad: XMLHttpRequest.timeout is only for async requests
    setTimeout(function(){ xhr.abort(); }, 300);
    try { xhr.send(is_xdr ? zescape.qs(data) : data); }
    catch(_e){ console.error('failed sending perr', _e); }
};

E.perr = function(opt){
    var qs = {}, data = {};
    qs.browser = b.browser;
    qs.id = opt.id;
    // XXX colin: use zua instead of navigator
    data.build = JSON.stringify({os: os, platform: navigator.platform,
        zua: navigator.userAgent});
    if (!opt.info || typeof opt.info!='string')
        opt.info = opt.info||{};
    data.info = opt.info && typeof opt.info!='string' ?
        JSON.stringify(opt.info) : opt.info;
    data.bt = opt.bt;
    data.filehead = opt.filehead;
    data.is_json = 1;
    var url = '//'+perr_url+'/client_cgi/perr?'+zescape.qs(qs);
    if (opt.use_beacon)
        return void E.send_beacon(url, to_form_data(data));
    return etask([function(){
        this.alarm(20000, {throw: 'timeout'});
        return $.ajax({type: 'POST', data: data, dataType: 'json',
            url: url});
    }]);
};

E.init = function(opt){
    perr_url = opt.perr_url;
};
return E; }); }());
